import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  deviceSelectedFulfilled,
  isNewClient,
  loadProfessions,
  loadProfessionsFulfilled,
  loadProfessionsRejected,
  selectUser
} from '../features/user.slice';
import { UserService } from '../services/user.service';

@Injectable()
export class AboutMeEffects {
  loadProfessions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProfessions, deviceSelectedFulfilled),
      concatLatestFrom(() => [this.store.select(isNewClient), this.store.select(selectUser)]),
      switchMap(([, isNewClient, user]) =>
        (isNewClient
          ? this.userService.getProfessionsBySerial(user?.devices?.[0].serial!)
          : this.userService.getProfessionsByUser(user?.id!)
        ).pipe(
          map((professions) => loadProfessionsFulfilled(professions)),
          catchError(() => of(loadProfessionsRejected()))
        )
      )
    )
  );

  constructor(private actions$: Actions, private userService: UserService, private store: Store) {}
}
